import { render, staticRenderFns } from "./ProfilesIndex.vue?vue&type=template&id=77a2618a"
import script from "./ProfilesIndex.vue?vue&type=script&lang=js"
export * from "./ProfilesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports